import { useState, useCallback, createContext, useContext } from 'react';
import { FONT_FAMILY } from '../constants/font';

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 3000);
  }, []);

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <div style={styles.container}>
        {toasts.map(t => (
          <div key={t.id} style={{
            ...styles.toast,
            background: t.type === 'error' ? '#FEF2F2' : t.type === 'warning' ? '#FFFBEB' : '#ECFDF5',
            borderColor: t.type === 'error' ? '#EF4444' : t.type === 'warning' ? '#F59E0B' : '#10B981',
            color: t.type === 'error' ? '#991B1B' : t.type === 'warning' ? '#92400E' : '#065F46',
          }}>
            <span style={styles.icon}>
              {t.type === 'error' ? '✕' : t.type === 'warning' ? '!' : '✓'}
            </span>
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

const styles = {
  container: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 99999,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  toast: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 18px',
    borderRadius: 10,
    border: '1px solid',
    fontSize: 13,
    fontWeight: 500,
    fontFamily: FONT_FAMILY,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    animation: 'slideIn 0.3s ease-out',
    minWidth: 240,
  },
  icon: {
    fontWeight: 700,
    fontSize: 14,
  },
};
